var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrafticon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5827 10H11.3327L9.91602 12.125H7.08268L5.66602 10H1.41602",
    stroke: "#C5C5C5",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85977 5.78625L1.41602 10.6667V14.9167C1.41602 15.2924 1.56527 15.6527 1.83095 15.9184C2.09662 16.1841 2.45696 16.3333 2.83268 16.3333H14.166C14.5417 16.3333 14.9021 16.1841 15.1678 15.9184C15.4334 15.6527 15.5827 15.2924 15.5827 14.9167V10.6667L13.1389 5.78625C13.0216 5.55022 12.8408 5.3516 12.6169 5.2127C12.3929 5.0738 12.1346 5.00014 11.871 5H5.12768C4.86412 5.00014 4.60583 5.0738 4.38184 5.2127C4.15785 5.3516 3.97705 5.55022 3.85977 5.78625V5.78625Z",
    stroke: "#C5C5C5",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafticon2);
export default __webpack_public_path__ + "static/media/drafticon2.4bd45b7f9447f462783500027f054582.svg";
export { ForwardRef as ReactComponent };